import React from 'react';
import {PiStudent} from "react-icons/pi";
import {VscBook} from "react-icons/vsc";
import {FaFlaskVial} from "react-icons/fa6";
import {GiProgression} from "react-icons/gi";
import {RiFontSize} from "react-icons/ri";
import classNames from "classnames";
import {Link} from "react-router-dom";
import {routes} from "../../utils/Routes";


export function ProductItem({token, className}) {
    const classInternal = classNames("bg-white m-0  rounded  border  " + className)
    return (
        <div className={classInternal} style={{fontFamily: "Poppins", minHeight: "100%"}}>
            <div className={"p-0 "} style={{fontFamily: "Poppins", minHeight: "100%"}}>
                <div className={"d-flex flex-column p-3 px-4"}>
                    <div className={"row"}>
                        <h3 className={"col"}>{token.productName}</h3>
                        <p className={"col-3 m-0 p-0 text-muted"}>[{token.courseCode}]</p>
                    </div>

                    {
                        token.slug.split("\n").map(paragraph => (
                            <p>{paragraph}</p>
                        ))
                    }


                    <div className={" d-flex mt-auto align-items-end border-top p-2"}>
                        <Link to={routes.storeProductAbs(token.productName)} className={"col btn btn-dark"}>Se mer</Link>
                    </div>
                </div>
            </div>
        </div>
    );

}